import { Text } from '@mantine/core';

interface PublicationPagesProps {
  startPage: number | null;
  endPage: number | null;
  noOfPages: number | null;
}

export function PublicationPages(props: PublicationPagesProps) {
  const { startPage, endPage, noOfPages } = props;
  return (
    <Text size="sm"> Pagini: {(startPage || endPage) && `${startPage ?? '?'}-${endPage ?? '?'} (${noOfPages})`}</Text>
  );
}
